export const VALIDATION_DEBOUNCE_TIME = 300;
export const EMPTY_PLACEHOLDER = '---';
export const STANDARD_DATE = 'dd/MM/yyyy';
export const STANDARD_DATE_TIME = 'dd/MM/yyyy HH:mm[hs]';
export const STANDARD_DATE_TIME_DOWNLOAD = 'dd-MM-yyyy HH-mm[hs]';
export const STANDARD_DATE_TIME_WITH_SECONDS = 'dd/MM/yyyy HH:mm:ss'; // this is used to all reports, if want to change change the format here
export const STANDARD_DATE_API = 'yyyy-MM-dd';
export const STANDARD_DATE_API_TIME = 'yyyy-MM-dd HH:mm:ss';
export const STANDARD_DATE_RANGE = 'MM/dd/yyyy';
export const STANDARD_TIME = 'HH:mm[hs]';
export const TABLE_INITIAL_VISIBLE_ROWS = 5;
export const INPUT_LOADING_TEXT = 'Cargando Opciones...';
export const INPUT_NO_OPTIONS_TEXT = 'No hay opciones';
export const TIME_ZONE = 'America/Buenos_Aires';
